import { AccountType, Goal, UserQuery } from "@ctypes";
import { convertCentsToDollar } from "./formatter";

const FIVE_TWO_NINE_ACCOUNT_TYPES: AccountType[] = [
  AccountType.FiveTwoNinePlan,
  AccountType.Individual_529,
];

export const isFiveTwoNineAccountType = (accountType?: AccountType | null): boolean =>
  !!accountType && FIVE_TWO_NINE_ACCOUNT_TYPES.includes(accountType);

export const calculateAccountBalance = (beneficiaries: UserQuery["beneficiaries"] = []) => {
  if (beneficiaries === null) return 0;

  const goals: Array<Goal | null> = [];

  beneficiaries.forEach((b) => {
    b?.goals?.forEach((g) => {
      goals.push(g);
    });
  });

  return goals
    .map((g) => convertCentsToDollar(g?.currentAmountInCents))
    .reduce((total, newBalance) => {
      const balance = newBalance ?? 0;
      return total + balance;
    }, 0);
};
